module.exports = __webpack_public_path__ + "static/interview02-ee84a37e1f28e8d2835c9c100160e44f.jpg";